import { connect, MapDispatchToProps } from 'react-redux';
import { subscriberConnect } from '../../../Discord/redux/actions';
import { Props } from './ConnectDiscord';

type DispatchProps = Pick<Props, 'subscriberConnect'>;
type OwnProps = Omit<Props, keyof DispatchProps>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  subscriberConnect,
};

export default connect(null, mapDispatchToProps);
